import { useCallback, useEffect, useState } from 'react';
import { useAppSelector } from '../../redux/hooks';
import AccountInfo from '../../components/account-info/AccountInfo';
import RecentlyAcquiredInventory from './dashboard-components/RecentlyAcquiredInventory';
import PendingTransactions from './dashboard-components/PendingTransactions';
import InventoryGraphics from '../../components/account-info/InventoryGraphics';
import NotificationBanner from '../../components/notificationBanner/NotificationBanner';
import { NOTIFICATION_CONSTANTS } from '../../constants/common';
import { getAnimalOwnershipsByAccountId } from '../../api/animalOwnersApi';
import AnimalOwnership from './dashboard-components/AnimalOwnership';

const Dashboard = (): JSX.Element => {
  const accountId = useAppSelector(state => state.activeAccount.accountId);
  const activeAccount = useAppSelector(state => state.activeAccount);
  const [userHaveAnimalOwnership, setUserHaveAnimalOwnership] = useState(false);


  const getTotalAnimalOwnershipsForAccount = useCallback(async () => {
    if (accountId) {
      try {
        const { data: animalOwnership } = await getAnimalOwnershipsByAccountId({ filter: `accountId eq ${accountId}` });
        setUserHaveAnimalOwnership(animalOwnership.length != 0);
      } catch (error: any) {
        throw new Error(error);
      }
    }
  }, [accountId]);

  useEffect(() => {
    getTotalAnimalOwnershipsForAccount();
  }, [getTotalAnimalOwnershipsForAccount]);

  return (
    <div className="dashboard">
      {activeAccount?.locked && (
        <div className="xs-notification-banner max-width">
          <NotificationBanner
            children={
              <div className="payment-details-not-found-notification">
                <p>{NOTIFICATION_CONSTANTS.ACCOUNT_LOCKED}</p>
              </div>
            }
          />
        </div>
      )}

      {accountId !== undefined && (
        <>
          <div className="card max-width">
            <AccountInfo accountId={accountId} />
          </div>
          <div className="card max-width">
            <InventoryGraphics accountId={accountId} />
          </div>
        </>
      )}

      <RecentlyAcquiredInventory />
      <PendingTransactions />
      <AnimalOwnership />
    </div>
  );
};

export default Dashboard;
